'use client';

import { nanoid } from 'nanoid';

import { useEffect, useState } from 'react';

import Image from 'next/image';

import { KalturaPlayerAPI } from '@carbon/ibmdotcom-services';
import { SkeletonPlaceholder } from '@carbon/react';

import { VideoPlayerContainerWrapper } from '@/components/carbon-web-components/VideoPlayerContainerWrapper';

export interface VideoPlayerProps {
  videoId: string;
  thumbnailAlt: string;
  play: boolean;
  showControls?: boolean;
  width?: number;
  height?: number;
  className?: string;
}

const defaultBounds = {
  width: 1300,
  height: 600,
};

export function VideoPlayer({
  videoId,
  thumbnailAlt,
  play,
  className,
  height,
  width,
  showControls = false,
}: VideoPlayerProps) {
  const [thumbnail, setThumbnail] = useState<string>();
  const id = nanoid();
  const bounds = { width: width || defaultBounds.width, height: height || defaultBounds.height };

  useEffect(() => {
    const thumbnailUrl = KalturaPlayerAPI.getThumbnailUrl({
      mediaId: videoId,
      height: bounds.height,
      width: bounds.width,
    });
    setThumbnail(thumbnailUrl);
  }, [bounds.height, bounds.width, videoId]);

  return (
    <div className={className} id={id}>
      {!thumbnail && <SkeletonPlaceholder className="w-full h-full object-cover" />}
      {thumbnail && !play && (
        <Image
          className="w-full h-full object-cover"
          src={thumbnail}
          alt={thumbnailAlt}
          width={bounds.width}
          height={bounds.height}
        />
      )}
      {play && (
        <VideoPlayerContainerWrapper
          videoId={videoId}
          backgroundMode={!showControls}
          hideCaption={true}
        />
      )}
    </div>
  );
}
